export default __webpack_public_path__ + "static/banner-main2-75d89acab528821485b31915c07932f3.png";